<template>
    <div class="card" :class="containerClass" @mouseenter="hover=true" @mouseleave="hover=false">
        <slot name="icon">
            <i :class="iconClass"/>
        </slot>
        <div :class="textContainerClass">
            <span v-if="name" v-html="name" :class="nameClass"></span>
            <b class="lh-1" :class="numberClass" v-if="number" v-html="number"></b>
        </div>
    </div>
</template>

<script>
import StatBase from '../../modules/stats/StatBase';

export default {
    extends : StatBase,
    name    : 'dashboard-stat'
};
</script>
